



























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { DxButton, DxTextBox, DxCheckBox, DxAutocomplete, DxSelectBox } from 'devextreme-vue';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Prop } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { InfractionDto } from '../../models/infractions/InfractionDto';
import { InfractionTypeDto } from '../../models/infractions/InfractionTypeDto';
import { InfractionModel } from '../../models/infractions/InfractionModel';
import { InfractionService } from '@/service/InfractionService';
import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import _ from 'lodash';
import CustomStore from 'devextreme/data/custom_store';
import ScrollView from 'devextreme/ui/scroll_view';
import CheckBox from 'devextreme/ui/check_box';
import DxList from 'devextreme-vue/list';
import List from 'devextreme/ui/list';
import { Popup } from '@questelservices/common-vue';
import { ManualCodeInvoiceLineItemDto } from '../../models/ManualCodeInvoiceLineItemDto';
import { ExecutiveSummaryRequestEnum } from '@/models/ExecutiveSummaryRequestEnum';

@Component({
        components: {
            DxButton,
            DxItem,
            DxList,
            DxScrollView,
            DxTextBox,
            DxValidator,
            DxRequiredRule,
            DxLoadPanel,
            DxCheckBox,
            DxAutocomplete,
            DxToolbar,
            DxToolbarItem,
            DxCustomRule,
            DxSelectBox,
            Popup
        }
    })
    export default class PhaseAssignmentInfractionsDialog extends Vue {
        $refs: Vue['$refs'] & {
            listPopup?: List;
        } = {};

        @Prop({ default: false })
        showDialog!: boolean;

        @Prop({ required: true })  
        lineItem!: ManualCodeInvoiceLineItemDto;
        
        @Prop({ required: true })
        infractionTypes!: InfractionTypeDto[];

        @Prop({ default: 'rgb(240, 240, 240)' })
        phaseColor!: string;

        get showingDialog(): boolean {
            return this.showDialog;
        }

        set showingDialog(value: boolean) {
            this.hidingInfractions(true);
        }

        private get infractionForm(): any {
          return this.$refs['addInfractionForm'];
        }

        private get listPopupRef(): any {
            return ((this.$refs.listPopup as List).instance as any);
        }

        @Watch('showDialog')
        onPropertyChanged(value: boolean, oldValue: boolean) {
           if (value) {

           } else {
               this.list = [];
           }
        }

        loadPanelPosition = { of : '#infractionDialog' };
        loadingVisible: boolean = false;
        list: InfractionTypeDto[] = [];
        infractionService: InfractionService;
        infractionTypesListSource: InfractionTypeDto[] = [];

        constructor() {
            super();
            this.infractionService = new InfractionService();
        }

        selectedInfraction: any[] = [];
        infractionListScroll?: any = undefined;

        getInfractionListSource(): InfractionTypeDto[] {
          let infractions = _.cloneDeep(this.infractionTypes);
          for (let lineItemInfraction of this.lineItem.Infractions) {
            let infraction = infractions.find(i => i.InfractionTypeId === lineItemInfraction.InfractionTypeId);
            if (infraction) {
              infraction.IsConfirmed = lineItemInfraction.IsConfirmed;
            }
          }

          let selected = infractions.find(i => i.IsConfirmed);
          if (selected) {
            this.selectedInfraction.push(selected);
          }

          return infractions;
        }

        handleScrollingToSelectedInfraction(): void {
            let selectedElement = document.getElementsByClassName('selected-infraction-popup')[0];
            if (selectedElement) {
                selectedElement.scrollIntoView(true);
            }
        }

        isSelectedInfractionClass(isConfirmed: boolean) {
            let deft = 'dx-template-wrapper dx-item-content dx-list-item-content';
            return isConfirmed ? 'selected-infraction-popup ' + deft : deft;
        }

        selectionOfInfraction(e: any): void {
            let elem = e.component;
            let items = elem.option().items;
            let isConfirmed = _.find(items, item => item.IsConfirmed);

            if (isConfirmed) {
                this.selectedInfraction = [];
                this.selectedInfraction.push(isConfirmed);
            }

            elem.option('selectedItems', this.selectedInfraction);
        }

        onContentReady(e: any): void {
            this.selectionOfInfraction(e);
            this.handleScrollingToSelectedInfraction();
        }

        scrollViewInit(e: any): void {
            this.infractionListScroll = e.component;   
        }

         listSelectionChanged(e: any): void {
            let removeItem = e.removedItems ? e.removedItems[0] : undefined;
            let addedItem = e.addedItems ? e.addedItems[0] : undefined;
            let items = e.component.option().items;

            if (removeItem) {
                removeItem.IsConfirmed = false;
            }

            if (addedItem) {
                this.selectedInfraction = [];
                let prevSelected = _.find(items, item => item.IsConfirmed);
                let currenctSelected = _.find(items, item => item.InfractionTypeId === addedItem.InfractionTypeId);

                if (prevSelected) {
                    prevSelected.IsConfirmed = false;
                }
                if (currenctSelected) {
                    currenctSelected.IsConfirmed = true;
                }
                
                this.selectedInfraction.push(currenctSelected);
            }

            this.handleScrollingToSelectedInfraction();
        }

        checkBoxComponent: any[] = [];
        onCheckBoxContentReady(e: any): void {
            this.checkBoxComponent.push(e.component);
        }
        
        onSelectedValueChanged(data: any): void {
            let a = data;
            let fond = _.find(this.checkBoxComponent, (item: any) => item === data.component);

            if (data.value) {
                let excludedElement = [];
                excludedElement.push(fond);

                let toUncheck = _.difference(this.checkBoxComponent, excludedElement);
                toUncheck.forEach((item: CheckBox) => {
                    item.option('value', false);
                });
            }
        }
        
        private addInfraction(): void {
            let newInfraction: InfractionTypeDto = {
                InfractionTypeId: undefined,
                Name: '',
                IsConfirmed: true
            };

            this.list.push(newInfraction);
        }

        private removeAt(index: number): void {
            this.list.splice(index, 1);
        }

        private hidingInfractions(isCancelled: boolean = true, lineItem?: ManualCodeInvoiceLineItemDto, reloadInfractionTypes: boolean = false): void {
            this.$emit('hiding', { isCancelled, lineItem, reloadInfractionTypes });
        }

        private save() {
            if (this.checkHasError()) {
                return;
            }

            if (this.list.length > 0) {
                if (_.find(this.list, item => item.Name === '')) {
                    return;
                }
            }

            if (this.list.length > 0) {
                this.addInfractions(this.lineItem.InvoiceLineItemId).then(response => {
                    this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.Infraction);
                    this.hidingInfractions(false, response, true);
                }).catch(err => {});
            } else {
                this.confirmInfractions(this.lineItem.InvoiceLineItemId).then(response => {
                    this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.Infraction);
                    this.hidingInfractions(false, response);
                }).catch(err => {});
            }
        }

        private async confirmInfractions(lineItemId: Guid): Promise<ManualCodeInvoiceLineItemDto> {
            let payload = '00000000-0000-0000-0000-000000000000';
            if (this.selectedInfraction && this.selectedInfraction.length > 0) {
                payload = this.selectedInfraction[0].InfractionTypeId;
            }

            return await this.infractionService.ConfirmInfractions(lineItemId, payload);
        }

        private async addInfractions(lineItemId: Guid): Promise<ManualCodeInvoiceLineItemDto> {
            return await this.infractionService.AddInfraction(lineItemId, this.list);            
        }

        onPopupShown(e: any): void {
            this.loadingVisible = true;
            this.infractionTypesListSource = this.getInfractionListSource();
            this.loadingVisible = false;
        }

        onPopupHiding(e: any): void {
            this.hidingInfractions(true);
            this.loadingVisible = false;
        }

        onPopupHidden(e: any): void {
            this.selectedInfraction = [];
            this.infractionTypesListSource = [];
        }

        private checkHasError(): boolean {
            return this.checkDuplication();
        }

        private checkDuplication(): boolean {
            if (this.list.length > 0) {
                let elem = _.find(this.infractionTypesListSource, t => t.Name.toLowerCase().trim() === this.list[0].Name.toLowerCase().trim());
                if (elem) {
                    return true;
                }
            }

            return false;
        }

        duplicationValidation(e: any): boolean {
            if (e.value.trim() !== '') {
                let elem = _.find(this.infractionTypesListSource, t => t.Name.toLowerCase().trim() === e.value.toLowerCase().trim());
                if (elem) {
                    return false;
                }
            }

            return true;
        }    
    }
